import { useSelector } from 'react-redux';

export const allowedPathsWhileFailedBilling = [
  '/login',
  '/choose-business',
  '/not-found',
  '/reset',
  '/inactive-business',
  '/permissions-needed',
  '/sso',
  '/create-new-business',
  '/payment-required',
  '/settings/billing',
  '/welcome',
];

export type BillingStatus =
  | 'ok'
  | 'blocked_new'
  | 'warn_failing'
  | 'warn_shutdown';

// We need to allow business info, in case they haven't added a credit card yet and
// don't have a business address set (which is required for credit cards)
export const allowedPatternWhileFailedBilling = /^\/settings\/business$/;

export const blockedRedirectPath = '/payment-required';

export const getBillingState = (billing_status?: BillingStatus) => {
  const isBlocked = billing_status === 'blocked_new';
  const isOkay = billing_status === 'ok';
  const isWarnFailing = billing_status === 'warn_failing';
  const isWarnShutdown = billing_status === 'warn_shutdown';

  return {
    isBlocked,
    isOkay,
    isWarnFailing,
    isWarnShutdown,
  };
};

export const useBillingState = () => {
  const business = useSelector((s: any) => s.authentication.chosenBusiness);
  let lockDate = business?.business_locking_day;

  if (lockDate) {
    lockDate = new Date(lockDate);
  }

  const state = getBillingState(business?.billing_status);

  return {
    ...state,
    lockDate,
  };
};
